import { CustomTableHeader } from '../../../../../components/CustomTable';
import {
  renderComponenteAF,
  renderStatusExecucao,
} from '../../ProcessosLicitatorios/auxiliarProcessosLicitatorios';

export const valoresExibidosOffCanvasOrgInters: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  statusOrgInter: 'Status',
  componenteAf: 'Componente',
  orgNome: 'Organização',
  orgSigla: 'Sigla',
  nupGeral: 'NUP Geral',
  nupEspecifico: 'NUP Específico',
  nProdutos: 'Nº de Produtos',
  valorTotal: 'Valor Total R$',
  numeroTC: 'Nº Termo Cooperação',
  numeroTermoAjuste: 'Nº Termo Ajuste',
  nupTermoAjuste: 'Nº SEI do Termo Ajuste',
  dataInicio: 'Data de Início',
  dataVigencia: 'Data de vigência',
};

export const headersOrgInters = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Status', width: 12, key: 'statusOrgInter' },
  { text: 'Componente', width: 12, key: 'componenteAf' },
  { text: 'Org. Internacional', width: 15, key: 'orgInternacional' },
  { text: 'NUP Específico', width: 20, key: 'nupEspecifico' },
  { text: 'N Produtos', width: 10, key: 'nProdutos' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const fieldObjectOrgInters = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export type OrgIntersTableRow = {
  id: string | number;
  statusOrgInter: string;
  componenteAf: string;
  orgInternacional: number | string;
  numeroTC: string;
  nupTermoAjuste: string;
  dataInicio: string;
  dataVigencia: string;
  [key: string]: any;
};

export const headersOrgIntersCustomTable: CustomTableHeader<OrgIntersTableRow>[] =
  [
    { text: '', width: 1, key: '', renderable: false },
    {
      text: 'ID',
      width: 4,
      key: 'id',
      fieldType: 'number',
      textAlign: 'center',
    },
    {
      text: 'Status',
      width: 9,
      key: 'statusOrgInter',
      fieldType: 'select',
      renderCell: (value) => renderStatusExecucao(value),
    },
    {
      text: 'Componente AF',
      width: 9,
      key: 'componenteAf',
      fieldType: 'select',
      renderCell: (value) => renderComponenteAF(value),
    },
    {
      text: 'Org. Internacional',
      width: 10,
      key: 'orgInternacional',
      fieldType: 'text',
    },
    {
      text: 'Nº TC',
      width: 10,
      key: 'numeroTC',
      fieldType: 'text',
    },
    {
      text: 'NUP Termo Ajuste',
      width: 10,
      key: 'nupTermoAjuste',
      fieldType: 'select',
    },
    {
      text: 'Data Início',
      width: 7,
      key: 'dataInicio',
      fieldType: 'date',
    },
    {
      text: 'Data Vigência',
      width: 7,
      key: 'dataVigencia',
      fieldType: 'date',
    },
  ];
